import {combineReducers, createStore, applyMiddleware} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'

import apiMiddleware from 'middleware/api'
import apiReducer from 'reducers/api'
import createUserAcct from 'reducers/createUserAcct'
import loginUser from 'reducers/loginUser'
import verifyUser from 'reducers/verifyUser'
import resetPassword from 'reducers/resetPassword'
import appReducer from 'reducers/appReducer'
import inboxSetup from 'reducers/inboxSetup'
import mailInbox from 'reducers/mailInbox'
import emailInbox from 'reducers/emailInbox'
import contacts from 'reducers/contacts'
import usersNotification from 'reducers/usersNotification'
import knowledgebase from 'reducers/knowledgebase'
import settings from 'reducers/settings'
import settingsProductivity from 'reducers/settingsProductivity'
import settingsOrganisation from 'reducers/settingsOrganisation'
import settingsAutomations from 'reducers/settingsAutomations'
import settingsCustomFields from 'reducers/settingsCustomFields'
import settingsRouting from 'reducers/settingsRouting'
import settingsChannels from 'reducers/settingsChannels'
import addNewInvitee from 'reducers/addNewInvitee'
import analyticsOverview from 'reducers/analyticsOverview'
import analyticsConversation from 'reducers/analyticsConversation'
import analyticsUsers from 'reducers/analyticsUsers'
import analyticsMetrix from 'reducers/analyticsMetrix'
import analyticsHome from 'reducers/analyticsHome'
import analyticsSLA from 'reducers/analyticsSLA'
import analyticsCustomer from 'reducers/analyticsCustomer'
import analyticsKnowledgebase from 'reducers/analyticsKnowledgebase'
import analyticsTask from 'reducers/analyticsTask'
import activities from 'reducers/activities'
import billing from 'reducers/billing'
import loader from 'reducers/loader'
import attachment from 'reducers/attachment'
import assets from 'reducers/assets'
import settingsTasks from 'reducers/settingsTasks'
import analyticsAssets from 'reducers/analyticsAssets'
import kbVersionControl from 'reducers/kbVersionControl'
import settingsIntegrations from 'reducers/settingsIntegrations'
import roles from 'reducers/roles'
import timeTracking from 'reducers/timeTracking'
import segment from 'reducers/segment'
import statuspage from 'reducers/statuspage'
import analyticsStatuspage from 'reducers/analyticsStatuspage'
import analyticsStaffingPrediction from 'reducers/analyticsStaffingPrediction'
import analyticsTag from 'reducers/analyticsTag'
import clientPortal from 'reducers/clientPortal'
import settingsApps from 'reducers/settingsApps'

const rootReducer = combineReducers({
  apiReducer,
  createUserAcct,
  loginUser,
  verifyUser,
  statuspage,
  resetPassword,
  appReducer,
  addNewInvitee,
  inboxSetup,
  mailInbox,
  emailInbox,
  contacts,
  knowledgebase,
  usersNotification,
  settings,
  settingsProductivity,
  settingsOrganisation,
  settingsAutomations,
  settingsCustomFields,
  settingsRouting,
  settingsChannels,
  analyticsOverview,
  analyticsTag,
  analyticsConversation,
  analyticsUsers,
  analyticsMetrix,
  analyticsHome,
  analyticsSLA,
  analyticsCustomer,
  analyticsKnowledgebase,
  analyticsTask,
  analyticsAssets,
  analyticsStatuspage,
  analyticsStaffingPrediction,
  activities,
  billing,
  loader,
  attachment,
  assets,
  settingsTasks,
  kbVersionControl,
  settingsIntegrations,
  roles,
  timeTracking,
  segment,
  clientPortal,
  settingsApps,
})

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(apiMiddleware)))
window.store = store
export default store
